import BaseView from '../../base'
import {ModelInfo} from '../../../defines/model/model'
import CommonUtil from '../../../utils/common'

export default {
  name: 'BaseTrainView',
  mixins: [BaseView],
  components: {},
  model: {
    prop: 'modelInfo',
    event: 'change'
  },
  props: {
    modelInfo: ModelInfo
  },

  created () {
    if (this.$route.meta.trainType === 'train' ||
      CommonUtil.isNotEmpty(this.modelInfo.modelId)) {
      this.initialize()
    }
  },
  watch: {
    modelInfo () {
      this.$forceUpdate()
    }
  },
  methods: {
    initialize () {
    },
    getTrainView () {
      return this.$route.matched[0].instances.default
    },
    getTransformers () {
      return this.getTrainView().getTransformers()
    },
    getTransformerHyperParams (transformerId) {
      return this.getTrainView().getTransformerHyperParams(transformerId)
    },
    getTransformerSummary (transformerId) {
      return this.getTrainView().getTransformerSummary(transformerId)
    },
    getTransformerPackage (transformerPackageId) {
      return this.getTrainView().getTransformerPackage(transformerPackageId)
    },
    getDefaultTransformerPackage (categoryId) {
      return this.getTrainView().getDefaultTransformerPackage(categoryId)
    },
    getAlgorithms (categoryId) {
      return this.getTrainView().getAlgorithms(categoryId)
    },
    getAlgorithmHyperParams (categoryId, algorithmId) {
      return this.getTrainView()
        .getAlgorithmHyperParams(categoryId, algorithmId)
    },
    getAlgorithmId (algorithmId) {
      return this.getTrainView().getAlgorithmId(algorithmId)
    },
    getAlgorithmCategoryId (algorithmId) {
      return this.getTrainView().getAlgorithmCategoryId(algorithmId)
    },
    getAlgorithmSummary (algorithmId) {
      return this.getTrainView().getAlgorithmSummary(algorithmId)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/model/train/base.js